import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import SnackbarUtils from 'utils/SnackbarUtils';
import { Col } from '../../../../../components/Col';
import { CustomCard } from '../../../../../components/CustomCard';
import { CustomTextArea } from '../../../../../components/CustomTextArea';
import { GenericProjectCard } from '../../../../../components/GenericProjectCard';
import { Row } from '../../../../../components/Row';
import {
  PROJECT_STATUS_PENDENTE,
  PROJECT_STATUS_RASCUNHO,
} from '../../../../../library/ProjectStatus';
import { getStepSlug } from '../../../../../library/ProjectSteps';
import { projectEdit } from '../../../../../library/Routes';
import { openModal } from '../../../../../store/modules/ModalActions';
import {
  changeProjetoValue,
  loadHistoricoAvaliacoes,
  removerDocumento,
  saveProjeto,
  uploadDocumento,
} from '../../../../../store/modules/ProjetoActions';
import {
  etapaIsUnlocked,
  getProjectFilesByEtapa,
} from '../../../../../utils/ProjetoUtils';

class Etapa4Card2 extends GenericProjectCard {
  stepIndex = 5;

  validationResults = [false];

  constructor(props) {
    super(props);

    this.state = {
      ...(this.state || {}),
      descricaoIndiceFormativoChanged: false,
      sending: false,
    };

    this.setValue = this.setValue.bind(this);
    this.toSubmit = this.toSubmit.bind(this);
    this.saveUploadChanges = this.saveUploadChanges.bind(this);
  }

  UNSAFE_componentWillMount() {
    this.props.loadHistoricoAvaliacoes(this.props.projeto.id, 4);
  }

  descricaoIndiceFormativoIsValid() {
    return this.props.projeto.descricaoIndiceFormativo
      ? this.props.projeto.descricaoIndiceFormativo.length > 0
      : false;
  }

  changeSendingStatus(status) {
    this.setState({
      ...this.state,
      sending: status,
    });
  }

  saveUploadChanges() {
    let avaliacao =
      this.props.projeto.avaliacoes.length > this.stepIndex + 1
        ? this.props.projeto.avaliacoes[this.stepIndex]
        : {};
    avaliacao.etapa = this.stepIndex;
    avaliacao.status =
      avaliacao.status === PROJECT_STATUS_RASCUNHO
        ? PROJECT_STATUS_RASCUNHO
        : PROJECT_STATUS_PENDENTE;
    let documentos = [];
    this.props.projeto.documentos.map((file, index) => {
      documentos.push({
        principal: file.principal,
        caminho: file.id,
      });
      return index;
    });
    const data = {
      id: this.props.projeto.id,
      idUsuario: this.props.projeto.idUsuario,
      documentos: documentos,
      avaliacao,
    };
    this.props.saveProjeto(data);
  }

  toSubmit() {
    if (!this.itemsAreValid(this.validationResults)) {
      return;
    }
    this.changeSendingStatus(true);
    let avaliacao =
      this.props.projeto.avaliacoes.length > this.stepIndex + 1
        ? this.props.projeto.avaliacoes[this.stepIndex]
        : {};
    avaliacao.etapa = 4;
    avaliacao.status = PROJECT_STATUS_PENDENTE;
    const data = {
      id: this.props.projeto.id || null,
      idUsuario: this.props.projeto.idUsuario,
      descricaoIndiceInicial: this.props.projeto.descricaoIndiceInicial,
      descricaoIndiceFormativo: this.props.projeto.descricaoIndiceFormativo,
      consultaPublica: this.props.projeto.consultaPublica,
      avaliacao,
    };
    this.props.saveProjeto(
      data,
      () => {
        SnackbarUtils.enqueueSnackbar({
          message: this.props.languageValues.successCadastrarEtapa4,
          options: {
            variant: 'success',
          },
        });
        this.changeSendingStatus(false);
        this.props.history.push(
          projectEdit.getURLWithParams(
            this.props.projeto.id,
            getStepSlug(this.stepIndex + 1)
          )
        );
      },
      (error) => {
        SnackbarUtils.enqueueSnackbar({
          message:
            error.response.statusText ||
            this.props.languageValues.erroCadastrarEtapa4,
          options: {
            variant: 'error',
          },
        });
        this.changeSendingStatus(false);
      }
    );
  }

  render() {
    this.validationResults =
      !etapaIsUnlocked(this.stepIndex, this.props.projeto.avaliacoes) ||
      this.state.sending
        ? [false]
        : [this.descricaoIndiceFormativoIsValid()];
    return (
      <CustomCard
        stepIndex={this.stepIndex}
        titleHint={this.props.languageValues.hintEtapa4}
        CardHeaderPropTypes={{
          title: this.props.languageValues.etapa4,
        }}
        sending={this.state.sending}
      >
        <form
          className={this.getFormClasses(this.state.sending)}
          onSubmit={(event) => {
            event.preventDefault();
            this.toSubmit(event);
          }}
        >
          <Row className='form-row'>
            <Col cols={[12, 12, 12, 12, 12]}>
              <CustomTextArea
                label={this.props.languageValues.descricaoIndiceFormativo}
                name='descricaoIndiceFormativo'
                value={this.props.projeto.descricaoIndiceFormativo || ''}
                onChange={(event) => {
                  this.setValue(event);
                }}
                error={!this.descricaoIndiceFormativoIsValid()}
                counter={true}
                maxSize={2000}
                disabled={
                  this.props.lockedAllFields ||
                  this.state.sending ||
                  !etapaIsUnlocked(
                    this.stepIndex,
                    this.props.projeto.avaliacoes
                  )
                }
              />
            </Col>
          </Row>
          <Row className='form-row'>
            <Col cols={[12, 12, 12, 12, 12]}>
              {this.getUploaderButton(
                this.props.languageValues.uploadLabelButton,
                getProjectFilesByEtapa(
                  this.props.projeto.documentos,
                  4,
                  this.props.projeto.id
                ).length || 0,
                this.props.lockedAllFields ||
                  this.state.sending ||
                  !etapaIsUnlocked(
                    4,
                    this.props.projeto.avaliacoes
                  ),
                {
                  titleHint: this.props.languageValues.direitoImagemHint,
                  toUpload: this.props.uploadDocumento,
                  toRemove: (caminho) =>
                    new Promise((res, rej) => {
                      this.props.removerDocumento(caminho, res, rej);
                    }),
                  cooperativa: this.props.projeto.codigoCooperativa,
                  etapa: 4,
                  idProjeto: this.props.projeto.id,
                  fileList: getProjectFilesByEtapa(
                    this.props.projeto.documentos,
                    4,
                    this.props.projeto.id
                  ),
                  onChanged: (list) => {
                    this.mergeFiles(
                      this.props.projeto.documentos,
                      list,
                      4,
                      this.props.projeto.id
                    );
                    this.saveUploadChanges();
                  },
                  getRefreshedList: () => {
                    return getProjectFilesByEtapa(
                      this.props.projeto.documentos,
                      4,
                      this.props.projeto.id
                    );
                  },
                },
                this.props.openModal
              )}
            </Col>
          </Row>
          {this.getActionsRow([
            [
              null,
              this.getHistoryButton(
                this.props.languageValues.reviewButton,
                this.props.languageValues.etapa4,
                this.props.projeto.historico &&
                  this.props.projeto.historico[this.stepIndex]
                  ? this.props.projeto.historico[this.stepIndex]
                  : [],
                this.stepIndex,
                this.props.openModal
              ),
            ],
            [
              this.getPreviousButton(!this.state.sending),
              this.getFinalyButton(
                this.props.lockedAllFields ||
                  !this.itemsAreValid(this.validationResults),
                this.toSubmit
              ),
            ],
          ])}
        </form>
      </CustomCard>
    );
  }
}

const mapStateToProps = (state) => ({
  languageValues: state.languages.languageValues,
  projeto: state.projeto.projetoEditing,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      changeProjetoValue,
      saveProjeto,
      loadHistoricoAvaliacoes,
      openModal,
      uploadDocumento,
      removerDocumento,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Etapa4Card2));
